<template>
  <div v-on="$listeners"
       :style="style">
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'BaseHeader',
    inheritAttrs: false,
    props: {
      truncate: { type: Boolean, required: false, default: false },
    },
    data: function () {
      return {
        style: {
          boxSizing: 'border-box',
          display: 'inline-block',
          fontSize: '24px',
          fontWeight: 'bold',
        },
      };
    },
    created: function () {
      this.style = {
        ...this.style,
        lineHeight: this.$attrs.lineHeight ? this.$attrs.lineHeight : 'none',
        ...(this.truncate ? {
          display: 'block',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          width: '100%',
        } : {}),
        ...this.$attrs,
      };
    },
  };
</script>
